<template>
  <div class="distributionGoodsList">
        <div class="goods" v-for="(item) in list" :key="item.spu_id" @click="onBuy(item)">
            <div class="goodsImg">
                <img :src="item.goods_img">
                <div class="sellOver" v-show="item.is_sell_out">
                    <span>已售罄</span>
                </div>
            </div>

            <div class="infoBox">
                <div class="goodsNameBox">
                    <span class="hot" v-show="item.show_hot_icon">热门</span>
                    <span class="goodsName">{{ item.goods_title }}</span>
                </div>
                <div class="goodsBuyInfo">
                    <span class="goodsPrice">￥{{ item.goods_price }}<span class="text">起</span></span>
                    <!-- 产品说隐藏 -->
                    <!-- <span class="goodsSales">销量：{{ item.sales_volume }}</span> -->
                </div>
                <a href="javascript:void(0)" class="buy">立即购买</a>
            </div>
        </div>
  </div>
</template>

<script >

import {
    mapState
} from 'vuex'
export default {
    name: 'distributionGoodsList',
    components : {
    },
    data () {
        return {
            goods: {},
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin,
        }),
    },
    props: {
        /**
         * 秒杀商品列表数据源
         */
        list: {
            type: Array,
            required: true
        },
    },
    watch: {
    },
    created () {

    },
    activated () {

    },
    mounted () {

    },
    methods: {
        onBuy (item) {
            const { distribution_code } = this.$route.query
            // sstore_id=924&goods_id=2518&goods_type=agent&spu_id=2002
            this.$router.push({
                path: '/distributionDetail',
                query: {
                    // sstore_id: item.sstore_id, // 门店id
                    goods_id: item.goods_id, // 自增id
                    goods_type: item.goods_type, // 商品类型
                    spec_id: item.spec_id,
                    spu_id: item.spu_id, // 规格id
                    distribution_code: distribution_code, // 分销码
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "../../../assets/stylus/variables";
@import "../../../assets/stylus/mixin";

.distributionGoodsList
    padding 20px 12px
    .goods
        display inline-block
        // width 348px
        width 50%
        padding 0 8px
        box-sizing border-box
        border-radius 20px
        overflow hidden
        vertical-align top
        margin-bottom 14px
        .buy
            height 48px
            background-color #e60014
            border-radius 24px
            width 198px
            display block
            text-align center
            line-height 48px
            color #fff
            font-size 30px
            margin 0 auto
        .goodsImg
                width 100%
                height 348px
                overflow hidden
                background #fff
                position relative
                img
                    width 100%
                    height 100%
                .sellOver
                    background rgba(0,0,0, 0.5)
                    position absolute
                    top 0
                    left 0
                    width 100%
                    height 100%
                    display flex
                    justify-content center
                    align-items center
                    span
                        width 140px
                        height 140px
                        border-radius 140px
                        background rgba(0,0,0, 0.6)
                        text-align center
                        line-height 140px
                        color #fff
                        font-size 36px
                        display block

        .infoBox
            background #fff
            // height 218px
            padding 20px
            .goodsNameBox
                font-size 24px
                line-height 34px
                height 68px
                mutiLineTextOverFlow(2)
                .hot
                    width 54px
                    height 24px
                    line-height 28px
                    margin-right 10px
                    text-align center
                    background-color #fc2d2d
                    border-radius 12px
                    color #ffffff
                    font-size 18px
                    display inline-block
            .goodsBuyInfo
                margin 22px 0 30px 0
                justify-content space-between
                display flex
                .goodsPrice
                    font-size 30px
                    color #fc2d2d
                    .text
                        font-size 20px
                        margin-left 2px
                .goodsSales
                    font-size 24px
                    color #666
</style>
